<template>
	<div :class="'input-item ' + classList + ' ' + containerClasses" :style="styles">
		<label class="input-label" :for="id" v-if="label !== ''"
			>{{ label }}
			<icon type="help" class="not-mobile help-icon-for-field" v-if="help !== ''" :tooltip="help"></icon
		></label>
		<div class="input-field-block select-field-block">
			<select
				@focus="focus"
				@blur="blur"
				@change="update($event)"
				:tabindex="tabindex"
				:id="id"
				:name="name"
				v-model="selectedValue"
				:style="inputStyles"
				:class="'select ' + classList + ' ' + extraClasses"
				:autofocus="autofocus"
				:spellcheck="spellcheck"
				:autocomplete="autocomplete"
				:readonly="readonly"
				:disabled="disabled"
				:required="required"
			>
				<option v-if="placeholder !== ''" disabled :value="null">{{ placeholder }}</option>
				<option v-for="option in options" :value="option.value">{{ option.label }}</option>
			</select>
		</div>
		<p class="input-help only-mobile" v-if="help !== ''" v-html="help"></p>
	</div>
</template>

<script type="text/babel">
export default {
	props: {
		id: { default: "" },
		name: { default: "" },
		value: { default: null },
		options: { default: [] },
		placeholder: { default: "" },

		label: { default: "" },
		help: { default: "" },

		required: { default: false },
		disabled: { default: false },
		readonly: { default: false },
		autofocus: { default: false },
		spellcheck: { default: false },
		autocomplete: { default: "on" }, // on/off

		hasError: { default: false },
		hasSuccess: { default: false },
		isLoading: { default: false },
		isFull: { default: false },

		extraClasses: { default: "" },
		containerClasses: { default: "" },
		width: { default: null },
		tabindex: { default: null },
		size: { default: "regular" }, // regular, large
	},

	data: function () {
		return {
			generatedInputStyles: [],
			hasFocus: false,
			selectedValue: "",
		};
	},

	methods: {
		update(e) {
			this.$emit("input", this.selectedValue);
			this.$emit("change", this.selectedValue);
		},

		focus() {
			this.hasFocus = true;
			this.$emit("focus");
		},

		blur() {
			this.hasFocus = false;
			this.$emit("blur");
		},
	},

	watch: {
		options: function (newOptions) {
			this.selectedValue = this.value;
			this.$emit("input", this.selectedValue);
		},
		value: function (newValue) {
			this.selectedValue = this.value;
		},
	},

	computed: {
		styles() {
			let style = {};

			if (this.width !== null) {
				style["width"] = this.width;
			}

			return style;
		},

		inputStyles() {
			let style = {};

			this.generatedInputStyles.forEach(function (item) {
				style[item.type] = item.value;
			});

			return style;
		},

		classList() {
			let classList = "";

			classList += " size-" + this.size;

			if (this.label !== "") {
				classList += " has-label";
			}

			if (this.help !== "") {
				classList += " has-help";
			}

			if (this.hasSuccess) {
				classList += " has-success";
			}

			if (this.hasError) {
				classList += " has-error";
			}

			if (this.isLoading) {
				classList += " is-loading";
			}

			if (this.isFull) {
				classList += " is-full";
			}

			if (this.required) {
				classList += " is-required";
			}

			if (this.hasFocus) {
				classList += " has-focus";
			}

			return classList;
		},
	},

	mounted() {
		this.selectedValue = this.value;
	},
};
</script>
